import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export const DHIRAAGU__OU__REGIONS__NAME__COLUMN_ID = "912bb24a-1ecc-4781-a2ed-adecfc2d80a5" as Uuid;

export const DHIRAAGU__OU__ROCS__NAME__COLUMN_ID = "896102f7-c183-4467-bb97-ab87d1cf0473" as Uuid;

export const DHIRAAGU__OU__ROCS__CODE__COLUMN_ID = "c32fdb21-7256-42bb-aa5d-622a7d38d647" as Uuid;

export const DHIRAAGU__OU__ATOLLS__NAME__COLUMN_ID = "b3089b82-47c7-4ceb-8131-bbc1d13f8906" as Uuid;

export const DHIRAAGU__OU__ATOLLS__ABR__COLUMN_ID = "116ddfab-4f98-4a07-bfbb-fc73e776296b" as Uuid;

export const DHIRAAGU__OU__ISLANDS__LAT__COLUMN_ID = "fc04e322-be29-40f1-b031-cba67f4f8ff2" as Uuid;

export const DHIRAAGU__OU__ISLANDS__LONG__COLUMN_ID = "6d42a3b5-4c1e-4e2b-a1d3-8e7f4c2b1a9d" as Uuid;

export const DHIRAAGU__OU__ISLANDS__NAME__COLUMN_ID = "1e8c5f2a-3b6d-4a7c-9e1f-2d4a6b8c5e3f" as Uuid;

export const DHIRAAGU__OU__VIRTUAL_SHOWROOMS__LAT__COLUMN_ID = "7e1c2f4a-5b3d-4e6c-8a2f-1d9c3b5e7a1f" as Uuid;

export const DHIRAAGU__OU__VIRTUAL_SHOWROOMS__LONG__COLUMN_ID = "3a5f1e8b-2c7d-4a1f-9e3c-6b2d5a8e1c4f" as Uuid;

export const DHIRAAGU__OU__VIRTUAL_SHOWROOMS__NAME__COLUMN_ID = "8f2a4e1d-6c3b-4f7a-1e5c-2d9a3b6e5f1c" as Uuid;

export const DHIRAAGU__OU__SHOWROOMS__LAT__COLUMN_ID = "9c3b1e5f-4a2d-4f1c-7e6a-2b5d8c1a3e9f" as Uuid;

export const DHIRAAGU__OU__SHOWROOMS__LONG__COLUMN_ID = "2f6e1a4c-3d8b-4e2f-5c7a-1d9b3e6a8f2c" as Uuid;

export const DHIRAAGU__OU__SHOWROOMS__NAME__COLUMN_ID = "5a8d2c1f-6b4e-4a3c-9f1e-2d7c5b8a1e4f" as Uuid;

export enum DhiraaguOus {
    "Regions" = "b13e4f1a-6d7f-4b8b-812f-fb0a1f03a8a1",
    "ROCs" = "3b7cf7ec-e4ef-431a-8951-c280fbe8da04",
    "Atolls" = "e5e72d3d-9f2e-46b1-94b3-82b9fa013ab7",
    "Islands" = "c1f6d847-d78d-42ac-8e22-0a674b49f12f",
    "VirtualShowrooms" = "f6a3b72e-d544-45be-b2e4-b2019aaf035b",
    "Showrooms" = "a96d2ec1-77c1-4a49-9a36-762e4747b5cd",
}
